import { apiCall, ApiConfig } from '../../config/api'
import { Asn } from '../../interfaces/Asn/Asn'

export async function getAsnWithFilters(packingListId: number): Promise<Asn[]> {
  return await apiCall(
    'GET',
    `${ApiConfig.AsnApi}?PackingListId=${packingListId}&pageSize=100`
  )
    .then((response) => {
      return response.data.items
    })
    .catch((error) => console.log(error))
}

export async function deletePackingList(
  packingListId: number
): Promise<number> {
  return await apiCall(
    'DELETE',
    `${ApiConfig.PackingListApi}/SoftDelete?packingListId=${packingListId}`
  )
    .then((response) => {
      return response.status
    })
    .catch((error) => {
      return error.status
    })
}

export async function deleteAsn(asnId: number): Promise<number> {
  return await apiCall(
    'DELETE',
    `${ApiConfig.AsnApi}/SoftDelete?asnId=${asnId}`
  )
    .then((response) => {
      return response.status
    })
    .catch((error) => {
      return error.status
    })
}
